<template>
  <Popover
    v-bind="$attrs"
    :placement="placement"
    :disabled="disabled || busy || !allStaffs.length"
    v-on="$listeners"
    @show="beforeShow"
  >
    <template #popover>
      <StaffSelect v-close-popover :staff-list="allStaffs" @select="select" />
    </template>
    <slot />
  </Popover>
</template>

<script>
import { mapGetters } from 'vuex'
import Popover, { ClosePopover } from '@/components/molecules/Popover'
import StaffSelect from '@/components/molecules/StaffSelect'

/**
 * スタッフ選択Popover
 */
export default {
  name: 'StaffSelectPopover',
  components: {
    Popover,
    StaffSelect,
  },
  directives: {
    ClosePopover,
  },
  props: {
    placement: { type: String, default: 'top-start' },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      busy: false,
    }
  },
  computed: {
    ...mapGetters({
      allStaffs: 'staffs/all',
    }),
  },
  methods: {
    async beforeShow() {
      // 一人しかいない場合は表示せずに自動選択
      if (this.allStaffs.length === 1) {
        this.busy = true
        this.select(this.allStaffs[0])
        await this.$nextTick()
        this.busy = false
      }
    },
    select(staff) {
      this.$emit('select', staff)
    },
  },
}
</script>
